import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import CartoonSticker from "@/components/site/CartoonStickers";
import Faq from "@/components/site/Faq";

export default function FaqPage() {
    return (
        <div data-testid="faq-page">
            {/* HERO */}
            <section className="section relative gradient-warm overflow-hidden pb-10 md:pb-14">
                <span className="float-y absolute -top-10 right-10 h-40 w-40 rounded-full bg-[#F26B1F]/10 blur-3xl" />
                <CartoonSticker name="house" width={84} rotate={-6} className="hidden xl:inline-flex bottom-6 right-10" />

                <div className="container-atm relative">
                    <Reveal>
                        <span className="eyebrow">FAQ</span>
                        <h1 className="mt-4 max-w-3xl text-4xl font-semibold leading-[1.05] sm:text-5xl lg:text-6xl">
                            A few{" "}
                            <span className="bg-gradient-to-r from-[#F26B1F] to-[#FF8E47] bg-clip-text text-transparent">
                                quick answers.
                            </span>
                        </h1>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="mt-5 max-w-2xl text-base text-[#475569] md:text-lg">
                            Quick clarity on what AllTask Moves does, how we work, and what
                            clients can expect.
                        </p>
                    </Reveal>
                </div>
            </section>

            {/* FAQ ACCORDION */}
            <Faq
                eyebrow="Frequently asked"
                title="Everything you might want to know."
                intro="Tap any question to expand the answer. We update this list as new questions come up from clients."
            />

            {/* SERVICE BOUNDARIES + CTA */}
            <section className="section">
                <div className="container-atm">
                    <Reveal>
                        <div className="card-3d mx-auto max-w-3xl p-8 md:p-10">
                            <div className="flex items-start gap-4">
                                <span className="rounded-2xl bg-[#0E2A47] p-3 text-white">
                                    <ShieldCheck size={22} strokeWidth={1.6} />
                                </span>
                                <div className="flex-1">
                                    <h2 className="text-xl font-semibold">
                                        Still have a question?
                                    </h2>
                                    <p className="mt-3 text-[15px] leading-relaxed text-[#475569]">
                                        The fastest way to get a clear answer about your move
                                        is a free 20-minute consultation. We'll review your
                                        situation and recommend the next best step.
                                    </p>
                                    <Link
                                        to="/book?service=free_consultation"
                                        className="btn-primary mt-5 inline-flex"
                                        data-testid="faq-book-cta"
                                    >
                                        Book Free Consultation <ArrowRight size={16} />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </section>
        </div>
    );
}
